var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1728,
    height: 319,
    viewBox: "0 0 1728 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 121V317H1728.5V121H1686.5V185H1584.5V121H1556V32.5H1354V121H1286V162.5H1188V226H1152V147.5H1087.5V121L892 119.5V41H787.5V121H776V76.5H573.5V121L494.5 119.5L492 0H397V41H295V121H195.5V162H96V121H0Z",
    fill: "#242E3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193 199V318.5H1741.5V184H1559.5V38H1368.5V237.5H1169V151H969V237.5H784V79.5H577.5V273.5H384V199H193Z",
    fill: "#2B3443"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundUp);
export default __webpack_public_path__ + "static/media/background-up.9c87d36fa72e443976f3f170ba74cb3e.svg";
export { ForwardRef as ReactComponent };